module.exports = __webpack_public_path__ + "static/media/cap3-00-desk.42c02488.jpg";